<template>
    <v-btn small elevation=0  @click='toggleDisplayMode'>{{ textToggleButton }}</v-btn>
</template>

<script>
import { defineComponent, computed } from 'vue'
import i18n from '../../plugins/vue-i18n.js';

export default defineComponent({
  props: {
    displayMode: {
      type: String,
      required: true,
      validator: (val)=>(['ipa', 'text'].includes(val)) 
    },
    language: {
      type: String,
      required: true
    }
  },
  setup(props, context){
    const {emit} = context;

    const toggleDisplayMode = ()=>{
      const newDisplayMode = props.displayMode === 'ipa' 
        ? 'text'
        : 'ipa'
      emit('display-mode-changed', newDisplayMode)
    }

    const textToggleButton = computed(()=>(
      props.displayMode === 'ipa'
        ? i18n.t(`readonly.toggle_original`)
        : i18n.t('pages.ipa_translate.ipa')
    ))
    return {
      toggleDisplayMode,
      textToggleButton
    }
  }
})
</script>
